module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_6.ace17286.png";